import axios from '@/axiosInterceptor';

const state = () => ({
  testingMode: false,
  userCompanyId: null,
  carrierId: null,
  carrierHighwayAccount: null,
  brokerRules: null,
  brokerRulesAccount: null,
  brokerRuleTypes: null,
  carrierUsers: null,
  dispatcherConnections: null,
  brokerCarrierConnection: null,
  brokerCarrierConnectionLoaded: null,
  carrierOnboardingPacket: null,
  activeClassifications: [],
  carrierContract: null,
  carrierAgreement: null,
  isloading: false,
  // activeRuleCategories: {
  //     "Authority": false,
  //     "Insurance": false,
  //     "Culture": false,
  //     "Equipment": false,
  //     "Operations": false,
  // },
  // sectionRuleOverrideArrays: {
  //     "Authority": [],
  //     "Insurance": [],
  //     "Culture": [],
  //     "Equipment": [],
  //     "Operations": [],
  // },
  activeRules: [],
  scrollClassificationTo: null,
  ruleOverrides: null,
  overallRulesAssessmentStatus: null,
  ruleTypes: null,
  unassignedClassifications: null,
  enabledClassifications: null,
  currentConnectionClassification: null,
  /* within ruleTypeLabels, set value to null to hide */
  ruleTypeLabels: {
    interstate_carrier_authority_is_active:
      'Carrier must have active interstate authority.',
    authority_age_gteq_three_months:
      'Carrier must have at least 3 months of continuous authority.',
    authority_age_gteq_six_months:
      'Carrier must have at least 6 months of continuous authority.',
    bipd_insurance_limit_gteq_750_000:
      'Carrier must have minimum BIPD coverage of $750,000.',
    bipd_insurance_limit_gteq_1_000_000:
      'Carrier must have minimum BIPD coverage of $1,000,000.',
    cargo_insurance_limit_gteq_100_000:
      'Carrier must have minimum Cargo coverage of $100,000.',
    safety_rating_satisfactory_or_unrated:
      'If rated, carrier must have a satisfactory safety rating.',
    safer_operating_status_active:
      'Carrier must have a Safer operating status of active.',
    has_been_inspected_in_the_last_twenty_four_months:
      'Carrier must have recorded inspections within the past 24 months.',
    no_active_oos_orders:
      'Carrier must not have any active out of service orders.',
    has_verified_physical_location_activity: null,
    has_verified_manually_entered_identifier: null,
    general_liability_insurance_limit_gteq_1_000_000: null,
    // 'has_verified_physical_location_activity': 'Carrier must verify physical location or asset activity.',
    // 'has_verified_manually_entered_identifier': 'Carrier must verify manually entered identifier.'
  },
  /* within ruleTypeCategories, set value to null to hide */
  ruleTypeCategories: {
    interstate_carrier_authority_is_active: 'Authority',
    authority_age_gteq_three_months: 'Authority',
    authority_age_gteq_six_months: 'Authority',
    bipd_insurance_limit_gteq_750_000: 'Insurance',
    bipd_insurance_limit_gteq_1_000_000: 'Insurance',
    cargo_insurance_limit_gteq_100_000: 'Insurance',
    safety_rating_satisfactory_or_unrated: 'Operations',
    safer_operating_status_active: 'Operations',
    has_been_inspected_in_the_last_twenty_four_months: 'Operations',
    no_active_oos_orders: 'Operations',
    has_verified_physical_location_activity: null,
    has_verified_manually_entered_identifier: null,
    general_liability_insurance_limit_gteq_1_000_000: null,
    // 'has_verified_physical_location_activity': 'Operations',
    // 'has_verified_manually_entered_identifier': 'Authority'
  },
  carrierConnections: null,
  carrierConnectionsInProgress: null,
  carrierConnectionsDoNotDispatch: null,
  carrierConnectionsDismissed: null,
  allBrokerRuleOverrides: null,
  allBrokerRuleOverridesIndefinite: null,
  paymentTermOptions: null,
  pagination: {
    carriers: {},
    inProgress: {},
    onHold: {},
    doNotDispatch: {},
    dismissed: {},
    rules: {
      carriers: {},
      partially_passing: {},
      failed: {},
      incomplete: {},
    },
  },
  brokerClassifications: [],
  expressRules: {
    carriers: [],
    partially_passing: [],
    failed: [],
    incomplete: [],
  },
  insuranceCertificateRequests: [],
  insuranceCertificateRequestActivities: [],
  applyClassification: false,
  classificationScroll: false,
  explicitClassifications: null,
  connectionUploads: [],
  connectionUploadsLoading: false,
  reasonCodes: [],
  exclusionsRequiringApproval: [],
});

// getters
const getters = {
  brokerRulesAccount_Authority(state) {
    if (state.brokerRulesAccount && state.brokerRulesAccount?.length > 0) {
      return state.brokerRulesAccount.filter((data) => {
        return data.title == 'Authority';
      });
    }
  },
};

const connectionsLocalStorage = {
  'my-carriers': {
    storageResults: 'carrierConnectionSearchResults',
    storagePagination: 'carrierConnectionSearchResultsPagination',
    setResultsState: 'setCarrierConnections',
    setPagination: 'setPaginationCarriers',
  },
  'in-progress': {
    storageResults: 'carrierConnectionInProgressSearchResults',
    storagePagination: 'carrierConnectionInProgressSearchResultsPagination',
    setResultsState: 'setCarrierConnectionsInProgress',
    setPagination: 'setPaginationInProgress',
  },
  'on-hold': {
    storageResults: 'carrierConnectionOnHoldSearchResults',
    storagePagination: 'carrierConnectionOnHoldSearchResultsPagination',
    setResultsState: 'setCarrierConnectionsOnHold',
    setPagination: 'setPaginationOnHold',
  },
  'do-not-dispatch': {
    storageResults: 'carrierConnectionDoNotDispatchSearchResults',
    storagePagination: 'carrierConnectionDoNotDispatchSearchResultsPagination',
    setResultsState: 'setCarrierConnectionsDoNotDispatch',
    setPagination: 'setPaginationDoNotDispatch',
  },
  dismissed: {
    storageResults: 'carrierConnectionDismissedSearchResults',
    storagePagination: 'carrierConnectionDismissedSearchResultsPagination',
    setResultsState: 'setCarrierDismissed',
    setPagination: 'setPaginationDismissed',
  },
  'passing-assessment': {
    storageResults: 'passingAssessmentStorage',
    storagePagination: 'passingAssessmentPagination',
    setResultsState: 'setExpressRules',
    setPagination: 'setRulesPagination',
    category: 'carriers',
  },
  'partially-passing-assessment': {
    storageResults: 'partiallyPassingAssessmentStorage',
    storagePagination: 'partiallyPassingAssessmentPagination',
    setResultsState: 'setExpressRules',
    setPagination: 'setRulesPagination',
    category: 'partially_passing',
  },
  'failed-assessment': {
    storageResults: 'failedAssessmentStorage',
    storagePagination: 'failedAssessmentPagination',
    setResultsState: 'setExpressRules',
    setPagination: 'setRulesPagination',
    category: 'failed',
  },
  'incomplete-assessment': {
    storageResults: 'incompleteAssessmentStorage',
    storagePagination: 'incompleteAssessmentPagination',
    setResultsState: 'setExpressRules',
    setPagination: 'setRulesPagination',
    category: 'incomplete',
  },
};

// actions
const actions = {
  initializeStore({ commit }) {
    if (
      window.location.href.includes('broker/carriers/connections') ||
      window.location.href.includes('broker/carriers/my-carriers')
    ) {
      // eslint-disable-next-line no-unused-vars
      Object.entries(connectionsLocalStorage).forEach(([_, item]) => {
        const searchResults = localStorage.getItem(item.storageResults);
        const searchPagination = localStorage.getItem(item.storagePagination);

        if (searchResults && searchResults !== 'undefined') {
          // console.log('ITEM STORAGE', item, searchResults);
          if (item.category) {
            commit(item.setResultsState, {
              data: JSON.parse(searchResults),
              category: item.category,
            });
            commit(item.setPagination, {
              headers: JSON.parse(searchPagination),
              category: item.category,
            });
          } else {
            commit(item.setResultsState, JSON.parse(searchResults));
            commit(item.setPagination, JSON.parse(searchPagination));
          }
          commit('setLoading', false);
        }
      });
    }
  },
  async getBrokerRules({ dispatch, commit }, id) {
    if (id) {
      try {
        let res = await axios.get(
          process.env.API_MONITOR +
            '/api/v1/rules?q[company_id_eq]=' +
            id +
            '&q[carrier_id_null]=1&page=1&per_page=50&q[s]=id%20desc'
        );
        commit('setExclusionsRequiringApproval', res.data);
        if (res.data && res.data?.length > 0 && res.data[0]?.id) {
          let res2 = await axios.get(
            process.env.API_MONITOR + '/api/v1/rules/' + res.data[0].id
          );
          commit('setBrokerRules', res2.data);
          dispatch('setBrokerRuleTypes');
        }
        return res;
      } catch (e) {
        let status = e.response?.status;
        if (
          axios.isAxiosError(e) &&
          status &&
          [401, 403, 404, 422].includes(status)
        ) {
          return e.response;
        } else {
          throw e;
        }
      }
    } else {
      console.log('No company ID for user provided to getBrokerRules');
    }
  },
  async getBrokerRulesAccount({ dispatch }, id) {
    if (id) {
      try {
        let res = await axios.get(
          process.env.API_MONITOR +
            '/api/v1/rules?q[company_id_eq]=' +
            id +
            '&q[carrier_id_null]=1&page=1&per_page=50&q[s]=id%20desc'
        );
        if (res.data && res.data?.length > 0 && res.data[0]?.id) {
          dispatch('getRuleTypesAccount', res.data[0]);
        }
        return res;
      } catch (e) {
        let status = e.response?.status;
        if (
          axios.isAxiosError(e) &&
          status &&
          [401, 403, 404, 422].includes(status)
        ) {
          return e.response;
        } else {
          throw e;
        }
      }
    } else {
      console.log('No company ID for user provided to getBrokerRulesAccount');
    }
  },
  async uploadRuleOverride(_, rule) {
    const {
      isActive,
      expirationDate,
      carrierId,
      classificationId,
      isType,
      file,
    } = rule;
    const params = {
      rule_override: {
        is_active: isActive,
        expiration_date: expirationDate,
        carrier_id: carrierId,
        classification_id: classificationId,
        is_type: isType,
        file,
      },
    };
    try {
      const req = await axios.post(
        process.env.API_MONITOR + '/api/v1/rule_overrides/',
        params
      );
      return req;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getRuleTypes({ commit }) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/rules/is_types'
      );
      commit('setRuleTypes', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getRuleTypesAccount({ commit }, brokerRulesData) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/rules/is_types'
      );
      commit('setRuleTypes', res.data);
      if (brokerRulesData) {
        commit('setBrokerRulesAccount', brokerRulesData);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async setBrokerRuleTypes({ commit, state, rootState }) {
    if (
      state.brokerRules &&
      state.ruleTypes?.length > 0 &&
      state.ruleTypeCategories
    ) {
      let activeRules = [];
      state.ruleTypes.forEach(function (el) {
        if (state.brokerRules[el.name] == 2) {
          activeRules.push(el);
          let category = state.ruleTypeCategories[el.name];
          if (category) {
            commit('setRuleCategoryToActive', category);
          }
        }
      });
      commit('setActiveRules', activeRules);
      // if (state.carrierOnboardingPacket !== null ) {
      let rulesAssessment =
        state.carrierOnboardingPacket?.rules_assessment?.summary;
      if (!rulesAssessment) {
        rulesAssessment =
          rootState.carriers?.showCarrier?.rules_assessment?.summary;
        console.log('rulesAssessment from showCarrier...');
        console.dir(rulesAssessment);
      }
      commit('setRulesAssessmentResults', rulesAssessment);
      // }
    } else {
      console.log(
        'Either state.brokerRules, state.ruleTypes, or state.ruleTypeCategories is missing for setBrokerRuleTypes action (dirs below in order)'
      );
      // console.dir(state.brokerRules);
      // console.dir(state.ruleTypes);
      // console.dir(state.ruleTypeCategories);
      // console.log(state.ruleTypes?.length);
      // console.log(state.ruleTypeCategories?.length);
    }
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/rules/is_types'
      );
      commit('setRuleTypes', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getUsers({ commit }, id) {
    commit('setCarrierId', id);
    try {
      const params = new URLSearchParams({
        carrier_id: id,
        scope: 'onboarding',
      }).toString();

      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/users/redacted_users?${params}`
      );
      commit('setUsers', res?.data?.carrier_users);
      commit('setDispatcherConnections', {
        active: res.data?.active_dispatchers,
        inactive: res.data?.inactive_dispatchers,
        pending: res.data?.pending_dispatchers,
      });
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async checkCarrierHighwayAccount({ commit }, id) {
    commit('setCarrierId', id);
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/companies?q[carrier_id_eq]=' + id
      );
      commit('setCarrierHighwayAccount', res?.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getBrokerCarrierConnection(
    { dispatch, commit },
    { broker_id, carrier_id }
  ) {
    commit('setUserCompanyId', broker_id);
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/connections?q[issuer_id_eq]=' +
          broker_id +
          '&q[carrier_id_eq]=' +
          carrier_id +
          '&page=1&per_page=50'
      );
      if (res.data && res.data[0]) {
        commit('setBrokerCarrierConnection', res.data[0]);
        if (res.data[0]?.id !== null) {
          dispatch('getRuleOverrides', {
            broker_id: broker_id,
            carrier_id: carrier_id,
          });
          dispatch('getOnboardingPacketsByConnectionId', res.data[0].id);
          if (res.data[0].receiver?.signed_contract?.id) {
            dispatch(
              'getCarrierContract',
              res.data[0].receiver?.signed_contract?.id
            );
          }
        } else {
          dispatch('getRuleOverrides', {
            broker_id: broker_id,
            carrier_id: carrier_id,
          });
        }
        // if (res.data[0]?.receiver?.signed_contract?.url) {
        //     commit('setCarrierAgreement', res.data[0]?.receiver?.signed_contract?.url);
        // }
      } else {
        dispatch('getRuleOverrides', {
          broker_id: broker_id,
          carrier_id: carrier_id,
        });
        commit('setBrokerCarrierConnection', null);
        commit('setCarrierOnboardingPacket', null);
      }
      commit('setBrokerCarrierConnectionLoaded', true);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarrierContract({ commit }, contract_id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/onboarding_packet_contracts/' +
          contract_id
      );
      if (res.data) {
        commit('setCarrierContract', res.data);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getRuleOverrides({ dispatch, commit }, { broker_id, carrier_id }) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/rule_overrides?q[company_id_eq]=' +
          broker_id +
          '&q[carrier_id_eq]=' +
          carrier_id +
          '&page=1&per_page=50&q[s]=updated_at%20asc'
      );
      commit('setRuleOverrides', res?.data);
      dispatch('getRuleOverrideUsers');
      dispatch('getBrokerRules', broker_id);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getAllBrokerRuleOverrides({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/rule_overrides?q[company_id_eq]=' +
          id +
          '&q[s]=updated_at%20asc'
      );
      commit('setAllBrokerRuleOverrides', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async updateNotDispatch(_, { carrierId, note }) {
    const payload = {
      status: 'do_not_dispatch',
    };
    if (note) {
      payload.notes = note;
    }
    try {
      let res = await axios.patch(
        `${process.env.API_IDENTITY}/api/v1/connections/set_carrier_to_do_not_dispatch?carrier_id=${carrierId}`,
        payload
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async updateConnectionStatus(_, { id = null, status = null }) {
    const body = {
      connection: {
        status: status,
      },
    };
    try {
      let res = await axios.patch(
        `${process.env.API_IDENTITY}/api/v1/connections/${id}`,
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getRuleOverrideUsers({ commit, state, rootState }) {
    console.log('RuleOverrides', state.ruleOverrides);
    console.log(
      'RuleOverridesFromDetail',
      rootState.carriers?.showCarrier?.rules_assessment?.carrier_rule_overrides
    );
    // let overrideUsers = [];
    // let users = [];
    // state.ruleOverrides.forEach(function(el) {
    //     if (!(overrideUsers.includes(el.user_id))) {
    //         overrideUsers.push(el.user_id);
    //     }
    // });
    // try {
    //     console.log('Override rules,', overrideUsers)
    //     overrideUsers.forEach(async function(user_id) {
    //         let res = await axios.get(process.env.API_IDENTITY + "/api/v1/users?q[id_eq]="+ user_id);
    //         console.log('res.data for user');
    //         users.push(res.data[0]);
    //         if (users.length == overrideUsers.length) {
    //             console.log('Here users', users)
    //             commit("setRuleOverrideUsers", users);
    //         }
    //     });
    // } catch (e) {
    //     let status = e.response?.status
    //     if (axios.isAxiosError(e) && status && [401, 403, 404, 422].includes(status)) {
    //         return e.response
    //     } else {
    //         throw e
    //     }
    // }

    const { carrier_rule_overrides: ruleOverridesWithUsers } =
      rootState.carriers?.showCarrier?.rules_assessment || {};
    if (ruleOverridesWithUsers)
      commit('setRuleOverrideUsers', ruleOverridesWithUsers);
  },
  async createOverride({ dispatch, commit, state }, { payload, section }) {
    // if (section.isSection == true && state.sectionRuleOverrideArrays[section.title].length > 0) {
    //     dispatch("patchOverride", { "id": state.sectionRuleOverrideArrays[section.title][section.rule_index], "is_active": payload.rule_override.is_active, "is_last": section.rule_index_is_last });
    // } else {
    console.log('file data3...');
    console.dir(payload);
    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/rule_overrides',
        payload
      );
      if (res.data) {
        if (
          section.isSection == false ||
          (section.isSection == true && section.rule_index_is_last == true)
        ) {
          dispatch('getRuleOverrides', {
            broker_id: state.userCompanyId,
            carrier_id: state.carrierId,
          });
        }
        if (section.isSection == true) {
          commit('setSectionRuleOverrideArrays', {
            title: section.title,
            id: res.data?.id,
          });
        }
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
    // }
  },
  // eslint-disable-next-line no-unused-vars
  async getOverrideById({ commit }, id) {
    try {
      const req = await axios.get(
        process.env.API_MONITOR + '/api/v1/rule_overrides/' + id
      );
      return req;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async deactivateOverride({ dispatch, state }, { payload }) {
    // if (section.isSection == true && state.sectionRuleOverrideArrays[section.title].length > 0) {
    //     dispatch("patchOverride", { "id": state.sectionRuleOverrideArrays[section.title][section.rule_index], "is_active": payload.rule_override.is_active, "is_last": section.rule_index_is_last });
    // } else {
    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/rule_overrides/deactivate',
        payload
      );
      if (res.data) {
        dispatch('getRuleOverrides', {
          broker_id: state.userCompanyId,
          carrier_id: state.carrierId,
        });
        // if (section.isSection == false || (section.isSection == true && section.rule_index_is_last == true)) {
        //     dispatch('getRuleOverrides', { "broker_id": state.userCompanyId, "carrier_id": state.carrierId });
        // }
        // if (section.isSection == true) {
        //     commit("setSectionRuleOverrideArrays", { "title": section.title, "id": res.data?.id });
        // }
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
    // }
  },
  async patchOverride({ dispatch, state }, { id, is_active, is_last }) {
    try {
      let res = await axios.patch(
        process.env.API_MONITOR + '/api/v1/rule_overrides/' + id,
        {
          rule_override: {
            is_active: is_active,
          },
        }
      );
      if (res.data) {
        if (is_last == true) {
          dispatch('getRuleOverrides', state.userCompanyId);
        }
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  // async getDispatcherConnections({ commit }, id) {
  //     try {
  //         let res = await axios.get(process.env.API_IDENTITY + "/api/v1/dispatcher_connections?q[carrier_id_eq]="+ id +"&page=1&per_page=50");
  //         commit('setDispatcherConnections', res.data);
  //         return res;
  //     } catch (e) {
  //         let status = e.response?.status
  //         if (axios.isAxiosError(e) && status && [401, 403, 404, 422].includes(status)) {
  //             return e.response
  //         } else {
  //             throw e
  //         }
  //     }
  // },
  async getOnboardingPacketsByConnectionId({ dispatch }, connection_id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets?q[connection_id_eq]=' +
          connection_id +
          '&page=1&per_page=50&q[s]=id%20desc'
      );
      if (res?.data && res?.data?.[0] && res.data[0]?.id) {
        dispatch('getOnboardingPacket', res.data[0].id);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getOnboardingPacket({ dispatch, commit, state, rootState }, packet_id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/onboarding_packets/' + packet_id
      );
      commit('setCarrierOnboardingPacket', res.data);
      let rulesAssessment =
        state?.carrierOnboardingPacket?.rules_assessment?.summary;
      if (!rulesAssessment) {
        rulesAssessment =
          rootState.carriers?.showCarrier?.rules_assessment?.summary;
        console.log('rulesAssessment from showCarrier...');
        console.dir(rulesAssessment);
      }
      commit('setRulesAssessmentResults', rulesAssessment);
      if (res?.data && res?.data?.executed_contract?.id) {
        dispatch('getExecutedContract', res?.data?.executed_contract?.id);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getExecutedContract({ commit }, contract_id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packet_contracts/' +
          contract_id
      );
      if (res?.data) {
        commit('setExecutedContract', res?.data);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getMyCarriersRules({ commit }, { currentPage, query = '' }) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/subscriptions/for_broker_portal?page=' +
          currentPage +
          '&per_page=50&rules_assessment_eq=pass' +
          query
      );
      if (res.data) {
        commit('setExpressRules', { data: res.data, category: 'carriers' });
        commit('setRulesPagination', {
          headers: res.headers,
          category: 'carriers',
        });
        commit('setLoadLocalStorageSearchResults', {
          type: 'passing-assessment',
          data: res.data,
          pagination: res.headers,
        });
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getPartiallyPassingAssessmentRules(
    { commit },
    { currentPage, query = '' }
  ) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/subscriptions/for_broker_portal?page=' +
          currentPage +
          '&per_page=50&rules_assessment_eq=partial_pass' +
          query
      );
      if (res.data) {
        commit('setExpressRules', {
          data: res.data,
          category: 'partially_passing',
        });
        commit('setRulesPagination', {
          headers: res.headers,
          category: 'partially_passing',
        });
        commit('setLoadLocalStorageSearchResults', {
          type: 'partially-passing-assessment',
          data: res.data,
          pagination: res.headers,
        });
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getFailedAssessmentRules({ commit }, { currentPage, query = '' }) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/subscriptions/for_broker_portal?page=' +
          currentPage +
          '&per_page=50&rules_assessment_eq=fail' +
          query
      );
      if (res.data) {
        commit('setExpressRules', { data: res.data, category: 'failed' });
        commit('setRulesPagination', {
          headers: res.headers,
          category: 'failed',
        });
        commit('setLoadLocalStorageSearchResults', {
          type: 'failed-assessment',
          data: res.data,
          pagination: res.headers,
        });
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getIncompletedRules({ commit }, { currentPage, query = '' }) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/subscriptions/for_broker_portal?page=' +
          currentPage +
          '&per_page=50&rules_assessment_eq=incomplete' +
          query
      );
      if (res.data) {
        commit('setExpressRules', { data: res.data, category: 'incomplete' });
        commit('setRulesPagination', {
          headers: res.headers,
          category: 'incomplete',
        });
        commit('setLoadLocalStorageSearchResults', {
          type: 'incomplete-assessment',
          data: res.data,
          pagination: res.headers,
        });
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarrierConnectionsCarriers({ commit }, { currentPage, query = '' }) {
    commit('setLoading', true);

    const params = new URLSearchParams({
      'q[s]': 'updated_at desc',
      page: currentPage,
      per_page: 50,
    });

    // Parse the query string and add parameters
    if (query) {
      const queryParams = new URLSearchParams(query);
      queryParams.forEach((value, key) => {
        params.append(key, value);
      });
    }

    ['onboarded', 'needs_to_onboard_but_can_remain_active'].forEach((v) =>
      params.append('q[status_in][]', v)
    );

    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/connections/for_broker_portal?${params}`
      );
      if (res.data) {
        // let sorted = res?.data?.sort((a, b) => (a.legal_name > b.legal_name) ? 1 : - 1);
        let sorted = res?.data;
        commit('setCarrierConnections', sorted);
        commit('setPaginationCarriers', res.headers);
        commit('setLoadLocalStorageSearchResults', {
          type: 'my-carriers',
          data: res.data,
          pagination: res.headers,
        });
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      commit('setLoadLocalStorageSearchResults', {
        type: 'my-carriers',
        data: [],
        pagination: {
          currentpage: 1,
          totalpages: 1,
          totalitems: 0,
        },
      });
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    } finally {
      commit('setLoading', false);
    }
  },
  async getCarrierConnectionsInProgress(
    { commit, rootState },
    { currentPage, query = '' }
  ) {
    if (rootState.users.featureFlags?.connection_search_opensearch?.enabled) {
      query += '&q[latest_onboarding_packet_status_not_null]=1';
    }
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/connections/for_broker_portal?q[status_eq]=needs_to_onboard&q[is_dismissed_eq]=false&q[receiver_id_not_null]=1&q[latest_onboarding_packet_status_not_eq]=complete&q[latest_onboarding_packet_status_not_start]=held&q[s]=latest_onboarding_packet_updated_at+desc&page=' +
          currentPage +
          '&per_page=50' +
          query
      );
      if (res.data) {
        // let sorted2 = res?.data?.sort((a, b) => (a.legal_name > b.legal_name) ? 1 : - 1);
        let sorted2 = res?.data;
        commit('setCarrierConnectionsInProgress', sorted2);
        commit('setPaginationInProgress', res.headers);
        commit('setLoadLocalStorageSearchResults', {
          type: 'in-progress',
          data: res.data,
          pagination: res.headers,
        });
      }
    } catch (e) {
      let status = e.response?.status;

      commit('setLoadLocalStorageSearchResults', {
        type: 'in-progress',
        data: [],
        pagination: {
          currentpage: 1,
          totalpages: 1,
          totalitems: 0,
        },
      });
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getCarrierConnectionsOnHold({ commit }, { currentPage, query = '' }) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/connections/for_broker_portal?q[latest_onboarding_packet_status_start]=held&q[s]=latest_onboarding_packet_updated_at+desc&q[is_dismissed_eq]=false&page=' +
          currentPage +
          '&per_page=50' +
          query
      );
      if (res.data) {
        // let sorted4 = res?.data?.sort((a, b) => (a.legal_name > b.legal_name) ? 1 : - 1);
        let sorted3 = res?.data;
        commit('setCarrierConnectionsOnHold', sorted3);
        commit('setPaginationOnHold', res.headers);
        commit('setLoadLocalStorageSearchResults', {
          type: 'on-hold',
          data: res.data,
          pagination: res.headers,
        });
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getCarrierConnectionsDoNotDispatch(
    { commit },
    { currentPage, query = '' }
  ) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/connections/for_broker_portal?q[status_eq]=do_not_dispatch&q[s]=updated_at%20desc&page=' +
          currentPage +
          '&per_page=50' +
          query
      );
      if (res.data) {
        // let sorted4 = res?.data?.sort((a, b) => (a.legal_name > b.legal_name) ? 1 : - 1);
        let sorted4 = res?.data;
        commit('setCarrierConnectionsDoNotDispatch', sorted4);
        commit('setPaginationDoNotDispatch', res.headers);
        commit('setLoadLocalStorageSearchResults', {
          type: 'do-not-dispatch',
          data: res.data,
          pagination: res.headers,
        });
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async patchDismissACarrier(_, { carrierId, bool }) {
    try {
      let res = await axios.patch(
        `${process.env.API_IDENTITY}/api/v1/connections/${carrierId}`,
        {
          connection: {
            is_dismissed: bool,
          },
        }
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getDismissedConnections({ commit }, { currentPage = 1, query = '' }) {
    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/connections/for_broker_portal?q[is_dismissed_eq]=true&page=${currentPage}&per_page=50${query}`
      );
      commit('setCarrierDismissed', res.data);
      commit('setPaginationDismissed', res.headers);
      commit('setLoadLocalStorageSearchResults', {
        type: 'dismissed',
        data: res.data,
        pagination: res.headers,
      });
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getPaymentTermOptions({ commit }, company_id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/payment_terms?q[company_id_eq]=' +
          company_id
      );
      commit('setPaymentTermOptions', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getBrokerClassifications({ commit }, company_id) {
    console.log('getBrokerClassifications', company_id);
    const params = {
      'q[is_by_broker_election_true]': 1,
      'q[is_active_true]': 1,
      'q[company_id_eq]': company_id,
      'q[explicit_oauth_application_id_null]': 1,
    };
    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/classifications`,
        { params }
      );
      commit('setBrokerClassifications', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getActiveClassifications({ commit }, company_id) {
    try {
      // this should be updated to remove the classifications_ from ransack since you are querying
      // that model and not trying to traverse and association
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/classifications?q[is_active_true]=1&q[company_id_eq]=' +
          company_id
      );
      commit('setActiveClassifications', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getExplicitClassifications({ commit }, company_id) {
    const params = {
      'q[company_id_eq]': company_id,
      'q[explicit_classification_id_not_null]': 1,
    };
    try {
      let res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/oauth/applications`,
        { params }
      );
      commit('setExplicitClassifications', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getInsuranceCertificateRequests({ commit }, carrier_id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/insurance_certificate_requests?q[carrier_id_eq]=' +
          carrier_id +
          '&q[status_not_eq]=cancelled&q[s]=created_at+desc'
      );
      if (res?.data) {
        commit('setInsuranceCertificateRequests', res?.data);
      }
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getInsuranceCertificateRequestActivity({ commit }, idActivity) {
    try {
      const res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/insurance_activities/?q[insurance_certificate_request_id_eq]=${idActivity}&q[s]=id desc`
      );
      // commit("setInsuranceCertificateRequestActivity", { id: idActivity?.toString(), data: res?.data });
      if (res?.data) {
        commit('setInsuranceCertificateRequestActivity', res?.data);
      } else {
        commit('setInsuranceCertificateRequestActivity', []);
      }
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getUnassignedClassifications({ commit }, carrierId) {
    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/carriers/${carrierId}/rules_assessments_for_unassigned_classifications`
      );
      commit('setUnassignedClassifications', res.data);
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getConnectionClassification(
    { commit },
    { classificationId, carrierId }
  ) {
    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/connection_classifications?q[classification_id_eq]=${classificationId}&q[carrier_id_eq]=${carrierId}`
      );
      commit('setCurrentConnectionClassification', res.data);
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async applyClassificationOverride(
    _,
    { connectionId, classificationId, shipper, file }
  ) {
    try {
      const formData = new FormData();
      formData.append('connection_classification[connection_id]', connectionId);
      formData.append(
        'connection_classification[classification_id]',
        classificationId
      );
      formData.append('is_manual_override', true);
      formData.append('shipper', shipper);
      formData.append('document', file);

      let res = await axios.post(
        `${process.env.API_IDENTITY}/api/v1/connection_classifications`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async removeClassificationOverride(_, connectionClassificationId) {
    try {
      let res = await axios.delete(
        `${process.env.API_IDENTITY}/api/v1/connection_classifications/${connectionClassificationId}`
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getEnabledClassifications({ commit }, companyId) {
    const params = {
      'q[company_id_eq]': companyId,
      'q[is_active_true]': 1,
    };
    try {
      let res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/classifications`,
        { params }
      );
      commit('setEnabledClassifications', res.data);
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getConnectionUploads({ commit }, connectionId) {
    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/connections/${connectionId}/connection_uploads`
      );
      commit('setConnectionUploads', res.data);
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async uploadConnectionFile({ commit }, { file, connectionId }) {
    commit('setConnectionUploadsLoading', true);
    try {
      const formData = new FormData();
      formData.append('connection_upload[document]', file);
      formData.append('connection_upload[connection_id]', connectionId);

      let res = await axios.post(
        `${process.env.API_IDENTITY}/api/v1/connections/${connectionId}/create_connection_uploads`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    } finally {
      commit('setConnectionUploadsLoading', false);
    }
  },
  async getReasonCodes({ commit }) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR + '/api/v1/reason_codes?q[s]=id asc'
      );
      commit('setReasonCodes', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setExclusionsRequiringApproval(state, data = []) {
    state.exclusionsRequiringApproval = data.reduce((acc, rule) => {
      if (rule?.exclusions_requiring_approval?.length) {
        acc.push({
          classification_id: rule.classification_id,
          exclusions_requiring_approval: rule.exclusions_requiring_approval,
        });
      }
      return acc;
    }, []);
  },
  setReasonCodes(state, data) {
    state.reasonCodes = data;
  },
  setEnabledClassifications(state, value) {
    state.enabledClassifications = value;
  },
  setScrollClassificationTo(state, value) {
    state.scrollClassificationTo = value;
  },
  setActiveClassifications(state, data) {
    state.activeClassifications = data;
  },
  setDispatcherConnections(state, data) {
    state.dispatcherConnections = data;
  },
  setBrokerCarrierConnection(state, data) {
    state.brokerCarrierConnection = data;
  },
  setCarrierOnboardingPacket(state, data) {
    state.carrierOnboardingPacket = data;
  },
  setPaymentTermOptions(state, data) {
    state.paymentTermOptions = data;
  },
  setUsers(state, data) {
    state.carrierUsers = data;
  },
  setRuleTypes(state, data) {
    state.ruleTypes = data;
  },
  setBrokerRules(state, data) {
    state.brokerRules = data;
  },
  setBrokerRulesAccount(state, data) {
    let accountRules = [];
    state.ruleTypes.forEach(function (rt) {
      if (data[rt.name] == 2) {
        accountRules.push({
          title: state.ruleTypeCategories[rt.name],
          type: rt.name,
          label: state.ruleTypeLabels[rt.name],
        });
      }
    });
    state.brokerRulesAccount = accountRules;
  },
  setUserCompanyId(state, data) {
    state.userCompanyId = data;
  },
  setCarrierId(state, data) {
    state.carrierId = data;
  },
  setCarrierAgreement(state, data) {
    state.carrierAgreement = data;
  },
  setCarrierContract(state, data) {
    state.carrierAgreement = data;
  },
  setSectionRuleOverrideArrays(state, { title, id }) {
    state.sectionRuleOverrideArrays[title].push(id);
  },
  setRuleCategoryToActive(state, data) {
    if (state.activeRuleCategories[data] == false) {
      state.activeRuleCategories[data] = true;
    }
  },
  setRuleOverrides(state, data) {
    data.forEach(function (d) {
      d['user'] = null;
    });
    state.ruleOverrides = data;
  },
  setActiveRules(state, data) {
    let output = [];
    let categories = [];
    for (const [key, value] of Object.entries(state.activeRuleCategories)) {
      if (value == true) {
        categories.push(key);
        output.push({
          title: key,
          status: null,
          rules: [],
        });
      }
    }
    data.forEach(function (d) {
      let idx = categories.indexOf(state.ruleTypeCategories[d.name]);
      if (idx !== -1) {
        let overrides = [];
        if (state.ruleOverrides) {
          state.ruleOverrides.forEach(function (ro) {
            if (ro.is_type == d.name) {
              overrides.push(ro);
            }
          });
        }
        output[idx]['rules'].push({
          type: d.name,
          label: state.ruleTypeLabels[d.name],
          status: null,
          overrides: overrides,
        });
      }
    });

    state.activeRules = output;
  },
  setRulesAssessmentResults(state, data) {
    let rulesAssessment = { ...data };
    console.log('second rulesAssessment...');
    console.dir(rulesAssessment);
    let overallFail = false;
    let overallIncomplete = false;
    state.activeRules.forEach(function (obj, index) {
      let fail = false;
      let incomplete = false;
      let override = false;
      obj.rules.forEach(function (rule) {
        if (rulesAssessment[rule.type] !== 'pass') {
          if (rulesAssessment[rule.type] == 'incomplete') {
            //* Check overrides first
            if (
              rule.overrides?.length > 0 &&
              rule.overrides[parseInt(rule.overrides?.length - 1)]?.is_active ==
                true
            ) {
              override = true;
              rule.status = 'Override';
            } else {
              incomplete = true;
              rule.status = 'Incomplete';
            }
          } else {
            //* Check overrides first
            if (rule.overrides == []) {
              fail = true;
              rule.status = 'Fail';
            } else {
              if (
                rule.overrides?.length > 0 &&
                rule.overrides[parseInt(rule.overrides?.length - 1)]
                  ?.is_active == true
              ) {
                override = true;
                rule.status = 'Override';
              } else {
                fail = true;
                rule.status = 'Fail';
              }
            }
          }
        } else {
          if (
            rule.overrides?.length > 0 &&
            rule.overrides[parseInt(rule.overrides?.length) - 1]?.is_active ==
              true
          ) {
            override = true;
            rule.status = 'Override';
          } else {
            rule.status = 'Pass';
          }
          // rule.status = 'Pass';

          // below is testing only...remove after test
          // if (rule.overrides?.length > 0 && rule.overrides[parseInt(rule.overrides?.length - 1)]?.is_active == true) {
          //     rule.status = 'Override';
          //     fail = 'override';
          // } else {
          //     rule.status = 'Fail';
          // }
        }
      });

      if (fail == true) {
        //* At least 1 rule in this activeRule has failed and is not overridden, mark overall fail and set rule status accordingly
        overallFail = true;
        state.activeRules[index]['status'] = 'Fail';
      } else {
        if (incomplete == true) {
          //* No rules in this activeRule have failed, but least 1 rule in this activeRule that did not pass is incomplete and has not been overridden, mark overall incomplete and set rule status accordingly
          overallIncomplete = true;
          state.activeRules[index]['status'] = 'Incomplete';
        } else if (override == true) {
          //* No rules in this activeRule have failed, but least 1 rule in this activeRule that did not pass has been overridden, mark overall overridden and set rule status accordingly
          if (overallFail == false) {
            overallFail = 'override';
          }
          state.activeRules[index]['status'] = 'Override';
        } else {
          state.activeRules[index]['status'] = 'Pass';
        }
      }
    });
    if (overallFail == true) {
      state.overallRulesAssessmentStatus = 'Fail';
    } else if (overallIncomplete == true) {
      state.overallRulesAssessmentStatus = 'Incomplete';
    } else if (overallFail == 'override') {
      state.overallRulesAssessmentStatus = 'Override';
    } else {
      state.overallRulesAssessmentStatus = 'Pass';
    }
  },
  setCarrierConnections(state, data) {
    state.carrierConnections = data;
  },
  setCarrierConnectionsInProgress(state, data) {
    state.carrierConnectionsInProgress = data;
  },
  setCarrierConnectionsOnHold(state, data) {
    state.carrierConnectionsOnHold = data;
  },
  setCarrierConnectionsDoNotDispatch(state, data) {
    state.carrierConnectionsDoNotDispatch = data;
  },
  setCarrierHighwayAccount(state, data) {
    state.carrierHighwayAccount = data;
  },
  setCarrierDismissed(state, data) {
    state.carrierConnectionsDismissed = data;
  },
  setRuleOverrideUsers(state, data) {
    console.log('userdata');
    console.dir(data);
    state.ruleOverrides.forEach(function (ro) {
      let roUser = data.filter(function (d) {
        return d && d.id == ro.user_id;
      });
      console.log('roUser');
      console.dir(roUser);
      ro.user = roUser[0];
    });
  },
  setAllBrokerRuleOverrides(state, data) {
    state.allBrokerRuleOverrides = data;
    state.allBrokerRuleOverridesIndefinite = data.filter(function (d) {
      return d.expiration_date == '2080-01-01';
    });
  },
  setExecutedContract(state, data) {
    state.carrierContract = data;
  },
  setBrokerCarrierConnectionLoaded(state, data) {
    state.brokerCarrierConnectionLoaded = data;
  },
  setPaginationCarriers(state, headers) {
    state.pagination.carriers = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  setPaginationInProgress(state, headers) {
    state.pagination.inProgress = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  setPaginationOnHold(state, headers) {
    state.pagination.onHold = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  setPaginationDoNotDispatch(state, headers) {
    state.pagination.doNotDispatch = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  setPaginationDismissed(state, headers) {
    state.pagination.dismissed = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  setBrokerClassifications(state, data) {
    state.brokerClassifications = data;
  },
  setRulesPagination(state, { headers, category }) {
    state.pagination.rules[category] = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  setExpressRules(state, { data, category }) {
    state.expressRules[category] = data;
  },
  setInsuranceCertificateRequests(state, data) {
    state.insuranceCertificateRequests = data;
  },
  // setInsuranceCertificateRequestActivity(state, { id, data }){
  //     state.insuranceCertificateRequestActivities[id] = data;
  // },
  setInsuranceCertificateRequestActivity(state, data) {
    state.insuranceCertificateRequestActivities.push(data);
  },
  setUnassignedClassifications(state, data) {
    state.unassignedClassifications = data;
  },
  setCurrentConnectionClassification(state, data) {
    state.currentConnectionClassification = data;
  },
  setApplyClassification(state, data) {
    state.applyClassification = data;
  },
  setClassificationScroll(state, bool) {
    state.classificationScroll = bool;
  },
  setClassificationScrollId(state, data) {
    state.classificationScroll = data;
  },
  setExplicitClassifications(state, data) {
    state.explicitClassifications = data;
  },
  setConnectionUploads(state, data) {
    state.connectionUploads = data;
  },
  setConnectionUploadsLoading(state, data) {
    state.connectionUploadsLoading = data;
  },
  setLoading(state, data) {
    state.isLoading = data;
  },
  setLoadLocalStorageSearchResults(state, { type, data, pagination }) {
    const localSearchStorage = connectionsLocalStorage[type];

    localStorage.setItem(
      localSearchStorage.storageResults,
      JSON.stringify(data)
    );
    localStorage.setItem(
      localSearchStorage.storagePagination,
      JSON.stringify(pagination)
    );
  },
  resetCarrierProfile(state) {
    state.userCompanyId = null;
    state.carrierId = null;
    state.carrierHighwayAccount = null;
    state.brokerRules = null;
    state.brokerRulesAccount = null;
    state.brokerRuleTypes = null;
    state.carrierUsers = null;
    state.dispatcherConnections = null;
    state.brokerCarrierConnection = null;
    state.brokerCarrierConnectionLoaded = false;
    state.carrierOnboardingPacket = null;
    state.activeClassifications = [];
    state.carrierContract = null;
    state.brokerClassifications = [];
    state.carrierAgreement = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
